module.exports = __webpack_public_path__ + "img/croix.632adf80.jpg";